import React from 'react';

class StoryInner extends React.Component {
    render(){
        return (
            <div className="story" id="story">
                <div className="aaaaaa"><h1>ストーリー</h1></div>
                <div className="story-inner">
                    <h2>この決断をあなたは許せるだろうか？</h2>
                    <h3>技能実習の職場から逃亡、他人になりすまして働きにきた中国人青年と、彼を受け入れる孤独な蕎麦職人。嘘の上に絆を強める二人を待つものとは――？<br className="pc_br" />その決断に心震えるヒューマンサスペンス。</h3>
                    <p>技能実習生として来日するも、劣悪な職場環境から逃げ出し、不法滞在者となってしまった中国人青年チェン・リャン。彼は他人になりすまし、蕎麦屋で働き口を見つける。口数が少なく不器用な蕎麦屋の主人・弘は、実の息子との関係も悪くどこか心に孤独を抱えていた。厳しくも温かい弘の背中に父を重ねるチェン・リャンと、彼の嘘をつゆ知らず情を深めていく弘――二人はまるで親子のような関係を築いていく。しかしはかない嘘の上に築いた幸せは長く続かず、チェン・リャンを追う警察の手が迫り、すべてを清算する日がやってくる。その時、二人はお互いのためにある決断をする――</p>
                </div>
            </div>
        );
    }
}

export default StoryInner;